import * as PIXI from "pixi.js"
//@ts-ignore
import { OutlineFilter } from 'pixi-filters';
import PixiScene from "../PixiScene";
//@ts-ignore
import PathProxy from "./PathProxy";

export default class PixiMouse extends PIXI.Container {

    private scene: PixiScene;
    public readonly lockSvg: PIXI.Sprite;
    public readonly hoverText: PIXI.Text;

    constructor(scene: PixiScene) {
        super();
        this.name = 'pixiMouse';
        this.scene = scene;

        const lock = {
            size: { width: 40, height: 30 },
            padding: { x: -4, y: -4 },
        };
        const svgPath = 'M2.03009 8.83291L2.03007 8.83292C1.41083 9.07451 1 9.70362 1 10.3497V16.5635C1 17.2068 1.40773 17.8322 2.01877 18.0772L2.01882 18.0773C3.86169 18.8163 5.80319 19.1913 7.78614 19.1913C9.76913 19.1913 11.7106 18.8162 13.5535 18.0772L13.5536 18.0772C14.1647 17.832 14.5722 17.2066 14.5722 16.5635V10.3497C14.5722 9.70355 14.1614 9.07456 13.5422 8.83289L13.5419 8.83277C13.5166 8.8229 13.4911 8.81305 13.4653 8.8032V6.73496V6.73491C13.4651 3.58306 10.9297 1 7.78617 1C4.64271 1 2.10708 3.58304 2.10708 6.73505V8.80319C2.08116 8.81309 2.05552 8.82299 2.03009 8.83291ZM7.90913 12.4764L7.78606 12.5502L7.66302 12.4764C7.55143 12.4095 7.5117 12.3199 7.5117 12.2422C7.5117 12.0708 7.64543 11.9526 7.78609 11.9526C7.92669 11.9526 8.06042 12.0708 8.06042 12.2422C8.06042 12.3199 8.02069 12.4096 7.90913 12.4764ZM9.85634 6.73496V7.87755C9.17033 7.78476 8.47795 7.73799 7.78666 7.73793H7.78658C7.09508 7.73793 6.4025 7.78476 5.71595 7.87759V6.73496C5.71595 5.56285 6.65664 4.62811 7.78609 4.62811L7.7861 4.62811C8.91555 4.62809 9.85634 5.56288 9.85634 6.73496Z';
        const pathProxy = new PathProxy(svgPath, lock.size.width, lock.size.height, window.devicePixelRatio || 1);
        pathProxy.update();
        this.lockSvg = new PIXI.Sprite(pathProxy.texture);
        this.lockSvg.anchor.set(0.5);
        this.lockSvg.position.set(lock.padding.x, lock.padding.y);
        this.addChild(this.lockSvg);
        const outlineFilter = new OutlineFilter(1, 0);
        this.lockSvg.filters = [ outlineFilter ];
        this.lockSvg.visible = false;

        const text = { padding: { x: 6, y: -12 } };
        const textStyle = new PIXI.TextStyle({
            fontFamily: 'Arial',
            fontSize: 16,
            fill: 0xffffff,
            stroke: 0,
            strokeThickness: 2,
        });

        this.hoverText = new PIXI.Text('', textStyle);
        this.hoverText.anchor.set(0, 1);
        this.hoverText.position.set(text.padding.x, text.padding.y);
        this.addChild(this.hoverText);
    }

    /**
     * Обновить состояние
     */
    public update(length: number = 0, locked: boolean = false): void
    {
        this.hoverText.text = length > 1 ? '' + length : '';
        this.lockSvg.visible = locked;
    }

    /**
     * Переместить в точку
     */
    public moveTo(x: number, y: number): void
    {
        this.x = x;
        this.y = y;
    }

}
